/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmployeeAttendanceRequest
 */
export interface CreateEmployeeAttendanceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmployeeAttendanceRequest
     */
    employeeId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateEmployeeAttendanceRequest
     */
    clockIn: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateEmployeeAttendanceRequest
     */
    clockOut?: Date;
}

/**
 * Check if a given object implements the CreateEmployeeAttendanceRequest interface.
 */
export function instanceOfCreateEmployeeAttendanceRequest(value: object): value is CreateEmployeeAttendanceRequest {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('clockIn' in value) || value['clockIn'] === undefined) return false;
    return true;
}

export function CreateEmployeeAttendanceRequestFromJSON(json: any): CreateEmployeeAttendanceRequest {
    return CreateEmployeeAttendanceRequestFromJSONTyped(json, false);
}

export function CreateEmployeeAttendanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeeAttendanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'clockIn': (new Date(json['clockIn'])),
        'clockOut': json['clockOut'] == null ? undefined : (new Date(json['clockOut'])),
    };
}

export function CreateEmployeeAttendanceRequestToJSON(json: any): CreateEmployeeAttendanceRequest {
    return CreateEmployeeAttendanceRequestToJSONTyped(json, false);
}

export function CreateEmployeeAttendanceRequestToJSONTyped(value?: CreateEmployeeAttendanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'clockIn': ((value['clockIn']).toISOString()),
        'clockOut': value['clockOut'] == null ? undefined : ((value['clockOut']).toISOString()),
    };
}

